import React, { useEffect, useRef, useState } from 'react';

interface SearchProps {
  value: string;
  placeholder: string;
  onValueChange: (value: string) => void;
}

const Search: React.FC<SearchProps> = ({
  value,
  onValueChange,
  placeholder
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onValueChange(value);
    setInputValue(value);
  };

  const handleClearSearch = () => {
    onValueChange('');
    setInputValue('');
  };

  return (
    <div className="tag-select-search-container">
      <i className="fa fa-search tag-select-search-icon" />
      <input
        ref={searchInputRef}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder={placeholder}
        className="tag-select-panel-search"
      />
      {inputValue !== '' && (
        <i
          className="fa fa-times tag-select-search-clear"
          onClick={handleClearSearch}
          title="Clear"
        />
      )}
    </div>
  );
};

export default Search;
